export const MORTGAGE_BANNER_VALUATION_LINK = `${process.env.NEXT_PUBLIC_CASAVO_MORTGAGES_WEBSITE}/come-possiamo-aiutarti?utm_source=lisa&utm_medium=valuationBanner&utm_campaign=interestedInBuying`
